import PropTypes from 'prop-types'
import React from 'react'
import { View } from 'components/View'
import { STYLES_PADDING } from 'modules/styles/constants/index.cjs'
import { compactArrayUtil } from 'packages/src'

class CommentButtons extends React.Component {
  render () {
    const children = compactArrayUtil(this.props.children)
    const count = React.Children.count(children)
    return (
      <div className='comment-buttons'>
        <View
          style={{
            flexDirection: View.DIRECTION.ROW,
            justifyContent: View.JUSTIFY.START
          }}
        >
          {
            React.Children.map(children, (button, i) =>
              (
                <div
                  style={{
                    paddingRight: i < count - 1 ? STYLES_PADDING.MEDIUM : null
                  }}
                >
                  {button}
                </div>
              )
            )
          }
        </View>
      </div>
    )
  }
}

CommentButtons.propTypes = {
  children: PropTypes.arrayOf(PropTypes.element).isRequired
}
export default CommentButtons
